import React from "react";

import { FaPause, FaPlay } from "react-icons/fa";

const CommonMindfulnessItem = ({ item, playing, onClick }) => {
  return (
    <>
      <div
        onClick={() => onClick(item)}
        className="bg-white border border-slate-300 rounded-lg"
      >
        <div className="relative">
          <img
            className="relativemb-2 h-40 w-full object-cover rounded-t-lg"
            src={item?.image}
            alt={item?.name}
          />

          <div className="absolute flex flex-row items-center bottom-0 left-0 right-0 w-full px-3 bg-black bg-opacity-40 py-2">
            {!playing ? (
              <FaPlay className="text-white" />
            ) : (
              <FaPause className="text-white" />
            )}
            <p className="text-base text-white font-medium ml-2">
              {item?.play_duration ?? ""}
            </p>
          </div>
        </div>
        <div className="h-20 md:h-16 px-3 py-2">
          <h4 className="font-medium text-black text-base text-ellipsis overflow-hidden">
            {item?.title ?? ""}
          </h4>
        </div>
      </div>
    </>
  );
};

export default CommonMindfulnessItem;
